// Same-origin API on every deployment (preview host, apex, www, any custom domain):
// the ingress routes /api to the backend on the same domain, so no CORS is involved.
// In-pod localhost dev keeps using REACT_APP_BACKEND_URL like the template default.
const isLocalhost = window.location.hostname === "localhost";

export const API = isLocalhost
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : `${window.location.origin}/api`;

export const TRACK_URL = isLocalhost
  ? `${process.env.REACT_APP_BACKEND_URL}/api/track/click`
  : "/api/track/click";
